// extracted by mini-css-extract-plugin
export default {"statusDot":"StatusDot_statusDot__xGdeJ","statusDot_active":"StatusDot_statusDot_active__UHCnF","statusDot_inactive":"StatusDot_statusDot_inactive__fbUw2"};